import React from 'react';

import {
  CheckoutBrand,
  CheckoutIcon,
  Container,
  ProductValueContainer,
  Section,
  Value,
  ValueContainer,
  ValueDescription,
  ValueGroup,
} from './styles';
import { ParcelasDTO } from '../../../../../../../dtos/ParcelasDTO';

type Props = {
  totalValue: number;
  installment: ParcelasDTO;
};

export function VehicleDebitsHeader({totalValue, installment} : Props) {
  const transformaMoeda = (value: number) => value.toLocaleString('pt-BR', {
    currency: 'BRL',
    style: 'currency',
  });
  return (
    <Container>
      <Section>
        <ProductValueContainer>
          <ValueContainer>
            <Value>{installment ? (installment.installmentCount + 'x ' + transformaMoeda(installment.valorMes) ) : transformaMoeda(totalValue)}</Value>
            <ValueGroup>
              <ValueDescription>Débitos veiculares</ValueDescription>
            </ValueGroup>
          </ValueContainer>
          <CheckoutBrand>
            <CheckoutIcon name="car" />
          </CheckoutBrand>
        </ProductValueContainer>
      </Section>
    </Container>
  );
}
